// ==========================================
// AuthContext.jsx — Authentication Context
// Provides global user authentication state
// ==========================================

import React, { createContext, useState, useContext } from "react";

// ========== 1. Create Context ==========
const AuthContext = createContext();

// ========== 2. AuthProvider Component ==========
// Wrap your app with <AuthProvider> to access authentication state
export const AuthProvider = ({ children }) => {
  // --- User state is initialized from localStorage for persistence ---
  const [user, setUser] = useState(() => localStorage.getItem("user") || null);
  const [userId, setUserId] = useState(null)
  // --- Store the intended path to redirect after login ---
  const [redirectPath, setRedirectPath] = useState("/");

  // ----- Login: Set user in state and localStorage -----
  const login = (useremail,userId) => {
    setUser(useremail)
    setUserId(userId)
    // localStorage.setItem("user", useremail);
  };

  // ----- Logout: Clear user from state and localStorage -----
  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  // --- Provide authentication data and actions to all descendants ---
  return (
    <AuthContext.Provider
      value={{
        user,
        userId,
        login,
        logout,
        redirectPath,
        setRedirectPath,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// ========== 3. Custom Hook for Consuming AuthContext ==========
export const useAuth = () => useContext(AuthContext);
